import {
  Modal,
  Form,
  FormGroup,
  ModalHeader,
  Col,
  Label,
  Input,
} from "reactstrap";
import 'assets/css/admin_user_filters_modal.css'

import React, { useEffect, useState } from 'react';
import { useFormik } from "formik";
import Select from "react-select";
import { filterLeadTypeOptions, getFilterModalLatestDateValue, getIANATimezoneStringForAbbreviation, getJsonStringForFilters, getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";
import { LEADS_FILTERED_COLUMNS_OBJECTS, LEADS_STATUS_OPTIONS, LEAD_TYPES, LEAD_TYPES_OPTIONS, PRODUCT_TYPE_IDS, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { usStatesOptions } from "common/data/us_states";
import DateRangePicker, { DATE_RANGE_OPTIONS, createOption } from 'components/Common/DateRangePicker';
import { useMemo } from "react";
import useFeatureFlags from "hooks/useFeatureFlags";

const filtersForLeads = Object.values(LEADS_FILTERED_COLUMNS_OBJECTS)

const LeadFilterModal = ({ isActive, modalState, currentAccountTimeZone, onSubmitModalState, onClickModalClose, campaignOptions, brandsOptions, show_rtb_brand_ui_changes }) => {

  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [isFeatureFlagActive] = useFeatureFlags();

  let modalStateDateOption = getFilterModalLatestDateValue(currentAccountTimeZone, DATE_RANGE_OPTIONS.THIS_MONTH, modalState?.received_value_label, modalState?.received_value)

  const [selectedDateRange, setSelectedDateRange] = useState(modalStateDateOption);

  const [selectedCountryState, setSelectedCountryState] = useState(getOptionFromValueForSelectBox(usStatesOptions, modalState?.state_value) || null);
  const [selectedLeadType, setSelectedLeadType] = useState(getOptionFromValueForSelectBox(LEAD_TYPES_OPTIONS, modalState?.lead_type_value) || null);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState(getOptionFromValueForSelectBox(LEADS_STATUS_OPTIONS, modalState?.status_value) || null);
  const [selectedCampaign, setSelectedCampaign] = useState(getOptionFromValueForSelectBox(campaignOptions, modalState?.campaign_name_value) || null);
  const [selectedBrand, setSelectedBrand] = useState(getOptionFromValueForSelectBox(brandsOptions, modalState?.brand_name_value) || null);
  const searchFilters = useMemo(() => {
    let filtersOfFilters = filtersForLeads.map(single => single.fieldName)
    if (selectedFilterName.length > 0) {
      filtersOfFilters = filtersOfFilters.filter((single_object, index) => filtersForLeads[index]?.name?.toLowerCase().includes(selectedFilterName.toLowerCase()))
    }
    return filtersOfFilters
  }, [selectedFilterName])

  useEffect(() => {
    setSelectedCountryState(getOptionFromValueForSelectBox(usStatesOptions, modalState?.state_value) || null);
    setSelectedLeadType(getOptionFromValueForSelectBox(LEAD_TYPES_OPTIONS, modalState?.lead_type_value) || null);
    setSelectedLeadStatus(getOptionFromValueForSelectBox(LEADS_STATUS_OPTIONS, modalState?.status_value) || null);
    setSelectedCampaign(getOptionFromValueForSelectBox(campaignOptions, modalState?.campaign_name_value) || null);
    setSelectedBrand(getOptionFromValueForSelectBox(brandsOptions, modalState?.brand_name_value) || null);
    if (modalState?.received_value_label) {
      setSelectedDateRange(modalStateDateOption);
    }
  }, [modalState])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      ...modalState
    },
    onSubmit: (values, { resetForm }) => {
      onSubmitModalState({
        ...values,
        state_value: getJsonStringForFilters(selectedCountryState),
        received_value: JSON.stringify(selectedDateRange?.value) || "",
        received_value_label: selectedDateRange?.original_label,
        lead_type_value: getJsonStringForFilters(selectedLeadType),
        status_value: getJsonStringForFilters(selectedLeadStatus),
        campaign_name_value: getJsonStringForFilters(selectedCampaign),
        brand_name_value: getJsonStringForFilters(selectedBrand),
      });
    }
  });


  const handleCountryState = (selectedObj) => {
    setSelectedCountryState(selectedObj);
  }

  const handleLeadStatus = (selectedObj) => {
    setSelectedLeadStatus(selectedObj);
  }

  const handleSelectedCampaign = (selectedObj) => {
    setSelectedCampaign(selectedObj);
  }

  const handleSelectedBrand = (selectedObj) => {
    setSelectedBrand(selectedObj);
  }

  const handleLeadType = (selectedObj) => {
    setSelectedLeadType(selectedObj);
  }

  const setDropdownValues = () => {
    setSelectedCountryState(JSON.parse(modalState?.state_value || "[]") || null);
    setSelectedLeadType(JSON.parse(modalState?.lead_type_value || "[]") || null);
    setSelectedLeadStatus(JSON.parse(modalState?.status_value || "[]") || null);
    setSelectedCampaign(JSON.parse(modalState?.campaign_name_value || "[]") || null)
    setSelectedBrand(JSON.parse(modalState?.brand_name_value || "[]") || null)
  }

  return (

    <Modal className="filter admin-filter-users"
      isOpen={isActive}
      backdrop={true}
      fade={false}
      backdropClassName="no-backdrop-color"
      toggle={onClickModalClose}
      scrollable={true}
      onOpened={() => setDropdownValues()}
    >
      <ModalHeader>
        <span className="modal-title text-black">Filters</span>
        <button type="button" className="close" onClick={onClickModalClose} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <div className="sf-admin-filters-position-relative">
        <Form onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}>
          <div className="mx-3" style={{ minHeight: '50vh' }}>
            <Col md="auto" className='align-self-center mt-3'>
              <FormGroup className="mb-0">
                <div className="search-box me-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                      className="rounded sf-box-w"
                      value={selectedFilterName}
                      placeholder="Search Filters"
                      onChange={(e) => {
                        setSelectedFilterName(e.target.value);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                        }
                      }}
                    />
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </FormGroup>
            </Col>
            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.FIRST_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-first_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-first-name"
                    type="checkbox"
                    name="first_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.first_name}
                    defaultChecked={validation.values.first_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-first-name" check>
                    First Name
                  </Label>
                </Col>
                {(validation.values.first_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="first_name_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.first_name_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.LAST_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-last_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-last-name"
                    type="checkbox"
                    name="last_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.last_name}
                    defaultChecked={validation.values.last_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-last-name" check>
                    Last Name
                  </Label>
                </Col>
                {(validation.values.last_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-last-name-value"
                      type="text"
                      name="last_name_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.last_name_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.PHONE.fieldName) &&
              <FormGroup className="mt-2" id="user-phone_num" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-phone_num"
                    type="checkbox"
                    name="phone_num"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone_num}
                    defaultChecked={validation.values.phone_num}
                  />
                  {' '}
                  <Label htmlFor="user-filter-phone_num" check>
                    Phone
                  </Label>
                </Col>
                {(validation.values.phone_num) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="phone_num_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.phone_num_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.EMAIL.fieldName) &&
              <FormGroup className="mt-2" id="user-email" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-email"
                    type="checkbox"
                    name="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    defaultChecked={validation.values.email}
                  />
                  {' '}
                  <Label htmlFor="user-filter-email" check>
                    Email
                  </Label>
                </Col>
                {(validation.values.email) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="email_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.STATE.fieldName) &&
              <FormGroup className="mt-2" id="user-state" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-state"
                    type="checkbox"
                    name="state"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.state}
                    defaultChecked={validation.values.state}
                  />
                  {' '}
                  <Label htmlFor="user-filter-state" check>
                    State
                  </Label>
                </Col>

                {(validation.values.state) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-first-name-value"
                      name="state_value"
                      options={usStatesOptions}
                      onChange={handleCountryState}
                      onBlur={validation.handleBlur}
                      value={selectedCountryState}
                      isMulti={true}
                      menuPlacement="auto"
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.CAMPAIGN_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-campaign_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-campaign-name"
                    type="checkbox"
                    name="campaign_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.campaign_name}
                    defaultChecked={validation.values.campaign_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-campaign-name" check>
                    Campaign Name
                  </Label>
                </Col>
                {(validation.values.campaign_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      id="user-filter-campaign-name-value"
                      name="campaign_name_value"
                      options={campaignOptions}
                      onChange={handleSelectedCampaign}
                      onBlur={validation.handleBlur}
                      value={selectedCampaign}
                      isMulti={true}
                      menuPlacement="auto"
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.LEAD_TYPE.fieldName) &&
              <FormGroup className="mt-2" id="user-lead_type" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-lead-type"
                    type="checkbox"
                    name="lead_type"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lead_type}
                    defaultChecked={validation.values.lead_type}
                  />
                  {' '}
                  <Label htmlFor="user-filter-lead-type" check>
                    Type
                  </Label>
                </Col>

                {(validation.values.lead_type) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-first-name-value"
                      name="lead_type_value"
                      options={
                        filterLeadTypeOptions(
                          PRODUCT_TYPE_IDS.LEADS,
                          LEAD_TYPES,
                          {
                            motorcycle_lead_type: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MOTORCYCLE_LEAD_TYPE_FOR_CLICKS),
                            group_health_lead_type: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE)
                          }
                        )
                      }
                      onChange={handleLeadType}
                      onBlur={validation.handleBlur}
                      value={selectedLeadType}
                      isMulti={true}
                      menuPlacement="auto"
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.STATUS.fieldName) &&
              <FormGroup className="mt-2" id="user-status" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-status"
                    type="checkbox"
                    name="status"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.status}
                    defaultChecked={validation.values.status}
                  />
                  {' '}
                  <Label htmlFor="user-filter-status" check>
                    Disposition
                  </Label>
                </Col>

                {(validation.values.status) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-status-value"
                      name="status_value"
                      options={LEADS_STATUS_OPTIONS}
                      onChange={handleLeadStatus}
                      onBlur={validation.handleBlur}
                      value={selectedLeadStatus}
                      isMulti={true}
                      menuPlacement="auto"
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.RECEIVED.fieldName) &&
              <FormGroup className="mt-2" id="user-received" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-received"
                    type="checkbox"
                    name="received"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.received}
                    defaultChecked={validation.values.received}
                  />
                  {' '}
                  <Label htmlFor="user-filter-received" check>
                    Received
                  </Label>
                </Col>
                {(validation.values.received) && (<>
                  <Col sm={12} className="mt-2">
                    <DateRangePicker
                      ianaTz={getIANATimezoneStringForAbbreviation(currentAccountTimeZone)}
                      menuPortalTarget={document.body}
                      menuPosition={'fixed'}
                      value={selectedDateRange}
                      options={Object.keys(DATE_RANGE_OPTIONS).map((opt) => createOption(
                        DATE_RANGE_OPTIONS[opt],
                        new Date(),
                        getIANATimezoneStringForAbbreviation(currentAccountTimeZone),
                      ))}
                      onChange={(value) => {
                        setSelectedDateRange(value);
                      }}
                    />
                  </Col>
                </>)}
              </FormGroup>}
            {show_rtb_brand_ui_changes && searchFilters.includes(LEADS_FILTERED_COLUMNS_OBJECTS.BRAND_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-brand_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-brand-name"
                    type="checkbox"
                    name="brand_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.brand_name}
                    defaultChecked={validation.values.brand_name}

                  />
                  {' '}
                  <Label htmlFor="user-filter-brand-name" check>
                    Brands
                  </Label>
                </Col>
                {(validation.values.brand_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      id="user-filter-brands-value"
                      name="brand_name_value"
                      options={brandsOptions}
                      onChange={handleSelectedBrand}
                      onBlur={validation.handleBlur}
                      value={selectedBrand}
                      isMulti={true}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      menuPlacement="top"
                    />
                  </Col>
                </>)}
              </FormGroup>}

          </div>
          <div className="modal-footer d-flex flex-wrap bg-white sf-admin-filters-position-sticky gap-2 pt-3">
            <button className={`btn ${getPrimaryButtonClass()} btn-sm`} type="submit">Update</button>
            <button className="btn btn-light btn-sm" type="reset" onClick={onClickModalClose}>Cancel</button>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

export default LeadFilterModal